import { render } from "./TransferForAllSalesmanActionTokoList.vue?vue&type=template&id=d15339ec&scoped=true"
import script from "./TransferForAllSalesmanActionTokoList.vue?vue&type=script&lang=js"
export * from "./TransferForAllSalesmanActionTokoList.vue?vue&type=script&lang=js"

import "./TransferForAllSalesmanActionTokoList.vue?vue&type=style&index=0&id=d15339ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d15339ec"

export default script